import type {ReactElement} from 'react';
import type {EmojiIconProps} from './emoji-icon.types';
import {EmojiIconSize} from './emoji-icon.types';
import styles from './emoji-icon.module.scss';

export function EmojiIcon({emoji, className = '', emojiClassName = '', emojiIconSize = EmojiIconSize.SMALL}: EmojiIconProps): ReactElement<any> {
  return (
    <div className={`${styles.emojiIconContainer} ${className} flex-center bg-neutral-3 radius-round ${emojiIconSize === EmojiIconSize.LARGE ? styles.large : styles.small}`}>
      <span className={`${emojiClassName} ${emojiIconSize === EmojiIconSize.LARGE ? 'heading-h4' : 'body-l'}`}>{emoji}</span>
    </div>
  );
}
